import type { FaireProductEntity } from "../../entity_types/product";

export const p_kqtd3n9wvs: FaireProductEntity = {
  token: "p_kqtd3n9wvs",
  type: "product",
  name: "Big Pickle Energy Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/dddb09c95160053cc84bba06c93c46ebdfc3ab0c3286d49b8014a0c1add173c9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/def916325d03f412e0cb033ec1f130b88fe71b65ea0a68b45bbf1b603b965bcd.jpeg",
    "https://cdn.faire.com/fastly/d5741b42ff90719ed6c8d8e8681fb76b233ac895c2424acd125087f0a3778a86.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/0a480b4dd4ac4e5259e52450d4ca0f0e33887aedc05b8305195db0e69ef40bd4.jpeg",
    "https://cdn.faire.com/fastly/80a0c46f146b2ab6de2378771302c985f6f983d1fe41d91445576648814e63cc.jpeg"
  ],
  priceDollars: 6.75,
  description: "You've got that Big Pickle swagger - you're a little sweet, maybe a little sour, but no matter where you go, you know you're the star of the show. These socks are for folks everywhere with that Big Pickle Energy. 🥒\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:22.826Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
